// extracted by mini-css-extract-plugin
export var alignCenter = "_8m-d";
export var bannerShown = "_8m-6";
export var buttonContent = "_8m-0";
export var cardList = "_8m-1";
export var centerContent = "_8m-2";
export var chevron = "_8m-3";
export var closePanelButton = "_8m-k";
export var conversationContextContainer = "_8m-l";
export var conversationDetailContainer = "_8m-4";
export var detailWrapper = "_8m-7";
export var dropdownButton = "_8m-e";
export var dropdownTitle = "_8m-9";
export var fullHeight = "_8m-5";
export var hidden = "_8m-a";
export var icon = "_8m-b";
export var mergeSuggestionWrapper = "_8m-m";
export var panel = "_8m-i";
export var portalButtonsWrapper = "_8m-c";
export var right = "_8m-j";
export var tableSummaryContainer = "_8m-8";
export var tableSummaryHeader = "_8m-g";
export var threeDotsButton = "_8m-f";
export var wide = "_8m-h";